import { useEffect, useState, useCallback, useMemo, lazy, Suspense } from "react";
import "./scss/WheelOfPrizes.scss";
import WheelOfPrizesWon from "./WheelOfPrizesWon";
import WheelOfPrizesLost from "./WheelOfPrizesLost";
import WheelOfPrizesRetry from "./WheelOfPrizesRetry";
import SubmitButton from "./SubmitButton";
import novibetImage from './novibet.png';

const PhaserWheel = lazy(() => import('../common/PhaserWheel'));

function vibrate(pattern = 200) {
	const supported = typeof navigator !== "undefined" &&
							"vibrate" in navigator &&
							typeof navigator.vibrate === "function";

	if (!supported) return false;           // not supported
	try {
		// Accepts a number (ms) or an array pattern: [vibrate, pause, vibrate, ...]
		return navigator.vibrate(pattern);    // returns true if scheduled, false otherwise
	} catch {
		return false;
	}
}

function WheelOfPrizes({ data, value, sending, elementErrors, onChange, onSubmit, goToNextPage, result, primaryTextColor, button, logout, isTryAgainPrize }) {
	// console.log('~WheelOfPrizes', data.id, value, elementErrors)
	const pathname = window.location.pathname;
	const campaignId = pathname.split('/')[1];
	const [screen, setScreen] = useState(null);
	const [spinning, setSpinning] = useState(false);
	const [loading, setLoading] = useState(false);
	const [mappedData, setMappedData] = useState(null);
	const [sliceIndex, setSliceIndex] = useState(null);
	const [spinResult, setSpinResult] = useState(null);
	const [isWheelReady, setIsWheelReady] = useState(false);

	const isNovibet = useMemo(() => {
		return ['pxYhIDJ3nAZ0ppKCZLce', 'CkYDNrwjZPJqs2DjCzNP', 'Focaphg4gEUycfwgvoXQ'].includes(campaignId);
	}, [campaignId])
	const shouldApplyWheelStyling = () => {
		return data.image || isNovibet
	}

	const defaultColors = [
		"#0466c8",
		"#023e7d",
		"#001845",
		"#33415c",
		"#5bba6f",
		"#137547",
		"#fbb13c",
		"#ffd97d",
		"#a4133c",
		"#ff758f",
		"#3a0ca3",
		"#3f37c9",
		"#4895ef"
	];

	const textColors = useMemo(() => {
		return data?.slices.reduce((acc, slice) => [...acc, ...[slice.textColor || '#fff']], [])
	}, [data]);

	const [tried, setTried] = useState(false);
	const spin = useCallback(() => {
		setLoading(true);
		setTimeout(() => {
			vibrate([500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500]);
		}, 1000);
		if(campaignId==="tjlt3HRqqEMQ1CfYwK0z"){
			const showTryAgain = Math.random()<.3;
			if(showTryAgain && !tried && data?.slices){
				setTried(true);
				const tryAgainArr = [];
				data.slices.forEach((slice, i)=>{
					if(slice.text.toLowerCase().trim()==="try again" && slice?.prizes?.length) {
						tryAgainArr.push({i, slice});
					}
				})
				const picked = tryAgainArr[0];

				const spinResult = {
					"retry": true,
					"sliceId": picked.slice.id,
					"sliceIndex": picked.i,
					"prize": {
						"id": picked.slice.prizes[0].id,
						"text": "",
						"description": "",
						"image": null,
						"probability": null,
						"stock": 20,
						"strategy": null
					}
				};

				setSpinResult(spinResult);
				setSliceIndex(parseInt(spinResult['sliceIndex']));
				setTimeout(() => {
					setLoading(false);
					setSpinning(true);
				}, 150);

				return;
			}
		}
		onSubmit(null, false);
	}, [onSubmit, tried])

	const setData = useCallback((data) => {
		setSpinning(false);
		vibrate(0);
		if (spinResult['retry']) {
			setScreen('retry')
		}else if (spinResult['won']) {
			setScreen('won')
		} else {
			setScreen('lost')
		}
	}, [spinResult])

	const borderImageStyling = useMemo(() => {
		if (!shouldApplyWheelStyling) return {};

		return {
			// backgroundImage: `url(${data.borderImage || '/images/common/border.png'})`,
			backgroundSize: `${data.borderImageSize || 130}%`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '50% center'
		}
	}, [data])

	useEffect(() => {
		let slices = data?.slices;

		if(data?.participationProbability == 1000000 && !data?.hasLosingSlice){
			slices = slices.filter((slice)=>slice.prizes.length>0);
		}
		const d = slices.map((slice, idx) => {
			let o = {
				option: slice.text,
				style: {
					backgroundColor: slice.color || defaultColors[idx],
					textShadowColor: slice.textShadowColor
				},
			}
			if (slice.image && slice.image !== '/images/common/placeholder.png') {
				o['image'] = { uri: slice.image, sizeMultiplier: slice.imageSizeMultiplier, offsetY: slice.imageOffsetY };
			}
			return o
		})
		setMappedData(d);
		onChange(data.id, true);
	}, [data])

	useEffect(() => {
		if (!result) return;
		Object.entries(result['responses']).forEach(([key, value]) => {
			if(!value['elements']){
				return;
			}
			Object.entries(value['elements']).forEach(([elKey, elValue]) => {
				if (!elValue['spinResult']) return;
				setSpinResult(elValue['spinResult']);
				setSliceIndex(parseInt(elValue['spinResult']['sliceIndex']));
				setTimeout(() => {
					setLoading(false);
					setSpinning(true);
				}, 150);
			})
		})
	}, [result])
	const spinDuration = Number.isFinite(data.spinDuration) ? data.spinDuration : 6;
	console.log("mappedData", mappedData)
	return (
		<div style={{ marginTop: data?.marginTop }} className="wheel_ofprizes">
			{screen === null &&
				<>
					{mappedData &&
						<Suspense>
							<>
								<div className="wheel__inner">
									<div className={`wheel__inner-wheel ${shouldApplyWheelStyling && 'wheel__inner-wheelBordered'}`} style={borderImageStyling}>
										{/* {data.centerImage && <img src={data.centerImage} className="wheel__inner-wheelNovibet"/> } */}
										{isNovibet && <img src={novibetImage} className="wheel__inner-wheelNovibet" />}

										<PhaserWheel
											mustStartSpinning={spinning}
											prizeNumber={sliceIndex}
											data={mappedData}
											borderImage={data.borderImage}
											centerImage={data.centerImage}
											centerImageSize={data.centerImageSize}
											pinImage={data.pinImage}
											pinImageSize={data.pinImageSize}
											backgroundColors={[defaultColors[0], defaultColors[1]]}
											buttonColor={data.buttonColor}
											textColors={textColors}
											borderStyle={data.borderStyle}
											borderColor={data.borderColor}
											borderWidth={data.borderWidth}
											onStopSpinning={setData}
											onCreate={() => setIsWheelReady(true)}
											spinDuration={spinDuration}
											startingOptionIndex={0}
											disableInitialAnimation={true}
											innerRadius={10}
											perpendicularText={data.perpendicularText || false}
										/>
									</div>
								</div>

								<div className="text--center">
									{(!loading && !spinning && isWheelReady) &&
										<SubmitButton
											text={data.buttonText || "Spin now"}
											size={button?.submitSize}
											onSubmit={spin}
											buttonStyle={{ borderRadius: button?.borderRadius, background: data.buttonColor, color: data.textColor }}
										/>
									}

								</div>
							</>
						</Suspense>
					}
					{(!isWheelReady || loading) &&
						<div className="text--center mtop--20">
							<div className="waveform">
								<div className="waveform__bar"></div>
								<div className="waveform__bar"></div>
								<div className="waveform__bar"></div>
								<div className="waveform__bar"></div>
							</div>
						</div>
					}

				</>
			}
			{screen === 'won' && <WheelOfPrizesWon next={goToNextPage} styling={data} data={spinResult} button={button} logout={logout} isTryAgainPrize={isTryAgainPrize} />}
			{screen === 'lost' && <WheelOfPrizesLost next={goToNextPage} styling={data} data={data} primaryTextColor={primaryTextColor} button={button} />}
			{screen === 'retry' && <WheelOfPrizesRetry tryAgain={()=>setScreen(null)} data={data} button={button} />}
		</div>
	);
};
export default WheelOfPrizes;
